import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import NutshellEnterprise from './icon-nutshell-enterprise.svg';

function SvgComponent() {
    return <NutshellEnterprise width={100} height={32} />;
}
SvgComponent.iconName = 'nutshellEnterprise';

export const NutshellEnterpriseIcon = svgIconWrapper(SvgComponent);
